export default "__VITE_ASSET__BmNt$e2x__"